module.exports = __webpack_public_path__ + "img/1.ad2eb1e6.svg";